import AbstractAction from "../AbstractAction";
import EventTypes from "../../../shared/EventTypes";

export default class UpdateLayerNameAction extends AbstractAction {
    constructor(provider, layer) {
        super(provider);

        this.layer = layer;
        this.oldName = layer.name;
        this.newName = layer.name;
    }

    update() {
        this.newName = this.layer.name;
        this.layer.row.label.html(this.newName);
    }

    finish() {
        this.newName = this.layer.name;
        if (this.newName === this.oldName) {
            super.discard();
            return;
        }
        this.layer.row.label.html(this.newName);
        this.emit(EventTypes.UPDATE_LAYER_NAME, this.layer);
        super.finish();
    }

    undo() {
        this.layer.name = this.oldName;
        this.layer.row.label.html(this.oldName);
        this.emit(EventTypes.UPDATE_LAYER_NAME, this.layer);
    }

    redo() {
        this.layer.name = this.newName;
        this.layer.row.label.html(this.newName);
        this.emit(EventTypes.UPDATE_LAYER_NAME, this.layer);
    }
}
